__turbopack_context__.v({
  "word": "ReadingText-module__SHeMEW__word",
});
